export function formatNumber(num, round = true) {
  if (!num) return 0;
  if (round) {
    num = num.toString();
    let decimals = num.split(".");
    if (decimals[1]) {
      decimals = decimals[1].length;
      decimals = decimals <= 2 ? 2 : decimals; /// force to 2 decimals min
      decimals = decimals >= 2 ? 2 : decimals; /// force to 3 decimals max
    } else {
      decimals = 0; /// no decimals
    }
    num = parseFloat(num);
    num = num.toFixed(decimals);
  }
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

/**
 * Evaluate a simple math expression on a price value.
 * Supports: plain numbers, +, -, *, / with numbers or percentages.
 * Examples: "150", "150+10", "150-10%", "200*2", "100/3"
 * Returns the computed number or null if the expression is incomplete/invalid.
 */
export function evalPriceExpr(expr) {
  if (!expr || typeof expr !== "string") return null;
  const str = expr.replace(/\s/g, "");

  // Plain number
  if (/^\d+(\.\d+)?$/.test(str)) return parseFloat(str);

  // Match: number operator number/percentage  e.g. 150+10%  or  200-30
  const match = str.match(
    /^(\d+(?:\.\d+)?)\s*([+\-*/])\s*(\d+(?:\.\d+)?)\s*(%?)$/
  );
  if (!match) return null;

  const base = parseFloat(match[1]);
  const op = match[2];
  const operand = parseFloat(match[3]);
  const isPercent = match[4] === "%";

  const val = isPercent ? base * (operand / 100) : operand;

  switch (op) {
    case "+":
      return base + val;
    case "-":
      return base - val;
    case "*":
      return isPercent ? base * (operand / 100) : base * operand;
    case "/":
      if (operand === 0) return null;
      return isPercent ? base / (operand / 100) : base / operand;
    default:
      return null;
  }
}

export const checkIfFileExists = async (url) => {
  const result = await fetch(url, { method: "HEAD" });
  return result.ok;
};
